module.exports = __webpack_public_path__ + "img/flip.10888a47.png";